module.exports = __webpack_public_path__ + "img/liwu.cea787de.gif";